import { useTranslation } from "@msuite/ui/localization";
import { getPlanStateColor, getPlanStateString } from "@msuite/utils/plans";
import type { Enums } from "@msuite/utils/types";
import { Tag, type TagProps } from "./tag";

/** Props Interface */
interface PlanStateTagProps extends Pick<TagProps, "variant"> {
	state: Enums<"planState">;
}

export function PlanStateTag({ state, variant = "plain" }: PlanStateTagProps) {
	/** Hooks */
	const { t } = useTranslation();
	const color = getPlanStateColor({ state });
	const translationKey = getPlanStateString(state);

	/** Render */
	return (
		<Tag
			color={color}
			variant={variant}
		>
			{t(translationKey)}
		</Tag>
	);
}
